// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.LaneHeader {\n    background-color: #999;\n    color: white;\n}\n\n.LaneHeader-title {\n\n}\n\n.LaneHeader-number {\n\n}\n\n.LaneHeader-openOrders {\n    background-color: #dc3545;\n}\n\n.LaneHeader-ordersInProgress {\n    background-color: #ffc107;\n}\n\n.LaneHeader-readyOrders {\n    background-color: #28a745;\n}\n", ""]);
// Exports
module.exports = exports;
